import { createAsyncThunk } from '@reduxjs/toolkit';
import { _teleServicePriceUrls } from '@custom/Utils/constants/apiUrls';

type payloadType = {
  _id: string;
};

// Async thunk to delete a teleservice price
export const deleteTeleServicePrice = createAsyncThunk(
  'deleteTeleServicePrice',
  async (payload: payloadType, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_teleServicePriceUrls?.delete, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response?.ok) {
        return rejectWithValue(`Failed to delete teleservice price. Status code: ${response?.status}`);
      }

      return await response.json(); // Return the response data if successful
    } catch (error: any) {
      return rejectWithValue(error.message); // Handle any errors that occur
    }
  }
);

export default deleteTeleServicePrice;
